
































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { Power4, TimelineLite } from 'gsap'

@Component
export default class App extends Vue {
  @Getter('mode') mode
  @Getter('title') title
  @Getter('firstTime') firstTime

  @Action('fetchProjects') fetchProjects
  @Action('fetchCategories') fetchCategories
  @Action('fetchOptions') fetchOptions
  @Action('setLightMode') setLightMode
  @Action('setTitle') setTitle
  @Action('removeFirstTime') removeFirstTime
  @Action('updateAnimation') updateAnimation

  timeline = new TimelineLite()
  pageTitle = null
  ready = false
  logoVisible = true
  direction = 'flex-end'
  initClass = 'init'
  showViewport = true

  @Watch('$route')
  updateLightMode() {
    this.setLightMode()
  }

  async created() {
    await this.fetchProjects()
    await this.fetchCategories()
    await this.fetchOptions()
    this.ready = true
  }

  @Watch('ready', { immediate: true })
  triggerAnimation(ready) {
    // Show Overlay for All Routes if Firstime
    if (this.firstTime && ready) {
      this.showLogo()
    }
  }

  resetFirst() {
    this.removeFirstTime()
    setTimeout(() => {
      this.initClass = 'not-init'
    }, 2000)
  }

  show() {
    this.updateAnimation(false)
    this.direction = 'flex-start'
    const first = this.firstTime
    const title = document.querySelector('head-title') as HTMLElement
    setTimeout(() => {
      if (this.$refs.overlay) {
        this.timeline.to(this.$refs.overlay, 0.3, { height: 4, transformOrigin: '50% 50%' })
        this.timeline.to(this.$refs.overlay, 0.3, { width: 0, transformOrigin: '50% 50%', onComplete: this.resetFirst })
      }
      if (title) {
        this.timeline.from(title, 0.5, { y: 30, autoAlpha: 1 })
      }
      setTimeout(() => {
        this.updateAnimation(true)
      }, 2500)
    }, 800)
  }

  showLogo() {
    this.timeline.from(this.$refs.logo, 1, { scale: 1.5 })
  }

  enter(el, done) {
    this.updateAnimation(false)
    this.showViewport = false
    this.direction = 'flex-start'
    this.pageTitle = el.getElementsByClassName('head-title')


    setTimeout(() => {
      if (this.$refs.bg) {
        this.timeline.to(this.$refs.bg, 1, { width: 0, ease: Power4.easeOut })
      }
    }, 1000)

    setTimeout(() => {
      this.updateAnimation(true)
    }, 1000)

    if (this.pageTitle) {
      this.timeline.from(this.pageTitle, 0.2, { y: 30, ease: Power4.easeOut, onComplete: done }, '+=1')
    }

  }

  updateDirection() {
    setTimeout(() => {
      this.direction = 'flex-start'
    }, 500)
  }

  mounted() {
    this.initClass = this.firstTime ? 'init' : 'not-init'
  }

  leave(el, done) {
    this.direction = 'flex-end'

    this.pageTitle = el.getElementsByClassName('head-title')
    const fullPage = el.getElementsByClassName('fullpage-wrapper')
    const arrows = el.getElementsByClassName('arrow')

    // if (fullPage) {
    //   this.timeline.from(fullPage, 0.5, { opacity: 0 })
    // }

    if (this.pageTitle) {
      this.timeline.to(this.pageTitle, 0.2, {y: 30, autoAlpha: 0,  ease: Power4.easeIn })
    }

    if (arrows) {
      this.timeline.to(arrows, 0.2, {y: 30, autoAlpha: 0,  ease: Power4.easeIn })
    }

    if (this.$refs.bg) {
      this.timeline.to(this.$refs.bg, 1, { width: '100%', ease: Power4.easeIn, onComplete: done })
    }

  }

  goToAbout() {
    this.setTitle('About')
    this.$router.push('/about')
  }

  goToPress() {
    this.setTitle('News')
    this.$router.push('/press')
  }

  goToContact() {
    this.setTitle('Contact')
    this.$router.push('/contact')
  }

  goToProjects() {
    this.setTitle('Projects')
    this.$router.push('/projects')
  }
}
